import React from 'react'
import { graphql } from 'gatsby'
import PageComponent from './PageComponent'
import './fragments'

const Page = (props) => {
  return <PageComponent {...props} />
}

export const query = graphql`
  query PageQuery($id: String!) {
    page: sanityPage(id: { eq: $id }) {
      id
      _type
      title
      summary
      author
      showToolbar
      post_date
      slug {
        current
      }
      color {
        title
        value
      }
      category {
        title
      }
      image {
        ...ImageWithMeta
      }
      seo {
        ...Seo
      }
      parentPage {
        id,
        slug {
          current
        }
      }
      slicesList {
        ...Slices
      }
    }
  }
`

export default Page
